import { ENDPOINTS, type FieldApplicabilityByTypeResponse } from '@clm/shared-types';

import { apiGet } from './client';

/**
 * `GET /v1/admin/field-applicability-by-type` — CLM-133 (FR-30 amendment,
 * D-131-1).
 *
 * The second read behind the Admin **Extraction accuracy** surface, beside
 * `fetchFieldAccuracy`. No parameters: nothing to filter or tune, and no
 * applies/doesn't-apply flag — that's deliberately not a thing this endpoint
 * decides. The response is parsed against the registry schema, whose
 * refinements pin the arithmetic (a null rate at `measured_contracts = 0`,
 * never 0), so an off-contract body is a `ZodError`, never a table showing a
 * plausible wrong number.
 *
 * NFR-06: no `scope` key is ever sent — scope is the API's, from the token;
 * `scope_kind` on the response is how the page learns it.
 */

const ENDPOINT = ENDPOINTS['field-applicability-by-type'];

export async function fetchFieldApplicabilityByType(signal?: AbortSignal): Promise<FieldApplicabilityByTypeResponse> {
  const raw = await apiGet<unknown>(ENDPOINT.path, signal === undefined ? {} : { signal });
  return ENDPOINT.response.parse(raw);
}
